'use client';
import cn from 'classnames';
import NextImage from 'next/image';
import { memo, useState } from 'react';

import styles from './ImgWrapper.module.scss';

const ImgWrapper = memo(
  ({
    imgUrl,
    alt,
    className,
    imgClassName,
    onError,
    hasItemProp,
    fetchPriority = 'low',
    priority = false,
    loading = 'lazy',
  }) => {
    const [errorUrl, setErrorUrl] = useState('');

    const imageSrc = errorUrl ? errorUrl : imgUrl || null;
    return (
      <span className={cn(styles.imgWrapper, className)}>
        {imageSrc && (
          <NextImage
            fill
            fetchPriority={fetchPriority}
            priority={priority}
            loading={loading}
            onError={() => setErrorUrl(onError)}
            className={cn(styles.img, imgClassName)}
            src={imageSrc}
            alt={alt}
            itemProp={hasItemProp ? 'image' : undefined}
          />
        )}
      </span>
    );
  },
);

export default ImgWrapper;
